import React from 'react'
import { PillCount, SelectedFiltersWrapper, StyledMobileFilterAndSort } from '../pill/pill.styles'
import { PILLS_CONTAINER_ID } from '../../constants/ids'
import { useSearchViewState } from '../../contexts/search-view-state-context'
import { IconFilter } from '@at/design-system-icons'
import { RenderPills } from './render-pills'
import { FacetSuggestionPills } from '../pill/facet-suggestion-pills'
import { useTrackingHandlers } from '../../hooks/tracking/tracking-handlers'

export interface FilterPillsMobileProps {
    filterPillLength: number
    handleClearAllButton: () => void
    isFilterSelected: boolean
}

export const FilterPillsMobile = ({ filterPillLength, isFilterSelected }: FilterPillsMobileProps) => {
    const { toggleSearchFilter } = useSearchViewState()
    const { trackOpenSearchModal } = useTrackingHandlers()

    return (
        <>
            <h1 className="visuallyhidden">Search Filters</h1>
            <SelectedFiltersWrapper data-testid={PILLS_CONTAINER_ID} id={PILLS_CONTAINER_ID}>
                <StyledMobileFilterAndSort
                    onClick={() => {
                        toggleSearchFilter(true)
                        trackOpenSearchModal()
                    }}
                    data-testid="search-filter-toggle"
                >
                    <IconFilter title="" viewBox="1 1 22 22" />
                    {filterPillLength > 0 ? <PillCount as="span">{filterPillLength}</PillCount> : null}
                </StyledMobileFilterAndSort>
                <RenderPills isFilterSelected={isFilterSelected} />
                <FacetSuggestionPills />
            </SelectedFiltersWrapper>
        </>
    )
}
